// SuperAdminDashboard.jsx - With Real API Integration
import React, { useState, useEffect } from 'react';
import { AppHeader } from '../components/ui/layout/app-header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';

import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuLabel, 
  DropdownMenuSeparator, 
  DropdownMenuTrigger 
} from '../components/ui/dropdown-menu';
import { useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { 
  Users, TrendingUp, DollarSign, Activity, 
  MoreHorizontal, Eye, ToggleLeft, ToggleRight,
  Shield, UserCircle, Settings, LogOut, Search,
  Menu, ArrowLeft, PlusCircle, Link, Ticket, Plane, LayoutDashboard, ClipboardCheck, BarChart3,
  Building, UserCheck, Loader2, RefreshCw,User,Megaphone
} from 'lucide-react';

import { BASE_URL } from '../lib/api';
export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  const [selectedPeriod, setSelectedPeriod] = useState('current-month');
  const [revenueYear, setRevenueYear] = useState('2024');
  const [searchTerm, setSearchTerm] = useState('');
  const [activeRevenueTab, setActiveRevenueTab] = useState('sales');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loadingDefaultPage, setLoadingDefaultPage] = useState(false);
  // Default Page Dialog State
const [defaultPageDialogOpen, setDefaultPageDialogOpen] = useState(false);
const [selectedUser, setSelectedUser] = useState(null);
const [selectedDefaultPage, setSelectedDefaultPage] = useState('maindashboard');
const [savingDefaultPage, setSavingDefaultPage] = useState(false);
 
  // Announcement Dialog State
  const [announcementDialogOpen, setAnnouncementDialogOpen] = useState(false);
  const [announcementForm, setAnnouncementForm] = useState({
    title: '',
    message: '',
    bg_color: '#16a34a',
    text_color: '#ffffff',
    is_active: true,
    start_date: '',
    end_date: ''
  });
  const [savingAnnouncement, setSavingAnnouncement] = useState(false);
  
  
  // Real data from API
  const [dashboardData, setDashboardData] = useState({
    statistics: {
      totalUsers: 0,
      confirmedUsers: 0,
      unconfirmedUsers: 0,
      ownersCount: 0,
      teamMembersCount: 0,
      totalOrganizations: 0
    },
    users: []
  });
  
  // Mock revenue data (keep this as is for demo)
  const [revenueData] = useState({
    totalSales: [
      { month: 'Jan', value: 21500, name: 'January' },
      { month: 'Feb', value: 23800, name: 'February' },
      { month: 'Mar', value: 21200, name: 'March' },
      { month: 'Apr', value: 22100, name: 'April' },
      { month: 'May', value: 19500, name: 'May' },
      { month: 'Jun', value: 24200, name: 'June' },
      { month: 'Jul', value: 18800, name: 'July' },
      { month: 'Aug', value: 19200, name: 'August' },
      { month: 'Sep', value: 20800, name: 'September' },
      { month: 'Oct', value: 22500, name: 'October' },
      { month: 'Nov', value: 21800, name: 'November' },
      { month: 'Dec', value: 25200, name: 'December' }
    ],
    mrr: [
      { month: 'Jan', value: 8500, name: 'January' },
      { month: 'Feb', value: 9200, name: 'February' },
      { month: 'Mar', value: 8800, name: 'March' },
      { month: 'Apr', value: 9500, name: 'April' },
      { month: 'May', value: 9800, name: 'May' },
      { month: 'Jun', value: 10200, name: 'June' },
      { month: 'Jul', value: 9600, name: 'July' },
      { month: 'Aug', value: 10100, name: 'August' },
      { month: 'Sep', value: 10800, name: 'September' },
      { month: 'Oct', value: 11200, name: 'October' },
      { month: 'Nov', value: 11500, name: 'November' },
      { month: 'Dec', value: 12000, name: 'December' }
    ],
    arr: [
      { month: 'Jan', value: 102000, name: 'January' },
      { month: 'Feb', value: 110400, name: 'February' },
      { month: 'Mar', value: 105600, name: 'March' },
      { month: 'Apr', value: 114000, name: 'April' },
      { month: 'May', value: 117600, name: 'May' },
      { month: 'Jun', value: 122400, name: 'June' },
      { month: 'Jul', value: 115200, name: 'July' },
      { month: 'Aug', value: 121200, name: 'August' },
      { month: 'Sep', value: 129600, name: 'September' },
      { month: 'Oct', value: 134400, name: 'October' },
      { month: 'Nov', value: 138000, name: 'November' },
      { month: 'Dec', value: 144000, name: 'December' }
    ]
  });

  const [adminUser, setAdminUser] = useState(null);

  // API call function
  const fetchSuperAdminData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('superadmin_token');
      
      if (!token) {
        throw new Error('No authentication token found');
      }

      console.log('Fetching SuperAdmin data...');

      const response = await fetch(`${BASE_URL}/authentication/superadmin/users`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 403) {
          throw new Error('Access denied. Super admin privileges required.');
        }
        if (response.status === 401) {
          throw new Error('Authentication failed. Please login again.');
        }
        throw new Error(`Failed to fetch data: ${response.status}`);
      }

      const data = await response.json();
      console.log('SuperAdmin API Response:', data);
      
      setDashboardData({
        statistics: data.statistics,
        users: data.users
      });
      
    } catch (error) {
      console.error('Error fetching super admin data:', error);
      setError(error.message);
      
      // If authentication failed, redirect to login
      if (error.message.includes('Authentication failed')) {
        localStorage.removeItem('superadmin_token');
        localStorage.removeItem('admin_user');
        navigate('/');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Get admin user from localStorage
    const adminData = localStorage.getItem('admin_user');
    if (adminData) {
      setAdminUser(JSON.parse(adminData));
    } else {
      // Redirect to login if no admin data
      navigate('/');
      return;
    }

    // Fetch real data on component mount
    fetchSuperAdminData();
  }, [navigate]);
// Announcement Functions
  const handleAnnouncementSubmit = async (e) => {
    e.preventDefault();
    setSavingAnnouncement(true);

    try {
      const token = localStorage.getItem('superadmin_token');
      
      if (!token) {
        throw new Error('No authentication token found');
      }

      // Prepare the data
      const announcementData = {
        title: announcementForm.title || null,
        message: announcementForm.message,
        bg_color: announcementForm.bg_color,
        text_color: announcementForm.text_color,
        is_active: announcementForm.is_active,
        start_date: announcementForm.start_date ? new Date(announcementForm.start_date).toISOString() : null,
        end_date: announcementForm.end_date ? new Date(announcementForm.end_date).toISOString() : null
      };

      const response = await fetch(`${BASE_URL}/announcements`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(announcementData)
      });

      if (!response.ok) {
        throw new Error('Failed to create announcement');
      }

      const result = await response.json();
      console.log('Announcement created:', result);

      // Reset form and close dialog
      setAnnouncementForm({
        title: '',
        message: '',
        bg_color: '#16a34a',
        text_color: '#ffffff',
        is_active: true,
        start_date: '',
        end_date: ''
      });
      setAnnouncementDialogOpen(false);

      // Show success message (you can add a toast notification here)
      alert('Announcement created successfully!');

    } catch (error) {
      console.error('Error creating announcement:', error);
      alert('Failed to create announcement. Please try again.');
    } finally {
      setSavingAnnouncement(false);
    }
  };
  // Default Page Functions
const openDefaultPageDialog = async (user) => {
  setSelectedUser(user);
  setDefaultPageDialogOpen(true);
  setLoadingDefaultPage(true); // Start loading
  
  // Set initial value from user object (for fallback)
  setSelectedDefaultPage(user.defaultpage || 'maindashboard');
  
  try {
    const token = localStorage.getItem('superadmin_token');
    
    if (!token) {
      console.error('No authentication token found');
      setLoadingDefaultPage(false);
      return;
    }

    // Fetch fresh data from GET API
    const response = await fetch(
      `${BASE_URL}/authentication/superadmin/users/${user.id}/defaultpage`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      console.error('Failed to fetch default page:', response.status);
      setLoadingDefaultPage(false);
      return;
    }

    const data = await response.json();
    
    if (data.success) {
      // Update with fresh server data
      setSelectedDefaultPage(data.data.defaultpage || 'maindashboard');
      
      // Update selected user with latest data
      setSelectedUser({
        ...user,
        defaultpage: data.data.defaultpage,
        fullName: data.data.fullName,
        email: data.data.email
      });
      
      console.log('[Get Default Page] Loaded:', data.data.defaultpage);
    }
  } catch (error) {
    console.error('[Get Default Page] Error:', error);
    // Dialog will continue with cached data from user object
  } finally {
    setLoadingDefaultPage(false); // Stop loading
  }
};
const handleDefaultPageSubmit = async () => {
  if (!selectedUser) return;
  
  setSavingDefaultPage(true);

  try {
    const token = localStorage.getItem('superadmin_token');
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(
      `${BASE_URL}/authentication/superadmin/users/${selectedUser.id}/defaultpage`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ defaultpage: selectedDefaultPage })
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update default page');
    }

    const result = await response.json();
    console.log('Default page updated:', result);

    // Update the user in the local state
    setDashboardData(prevData => ({
      ...prevData,
      users: prevData.users.map(u => 
        u.id === selectedUser.id 
          ? { ...u, defaultpage: selectedDefaultPage }
          : u
      )
    }));

    // Close dialog and reset
    setDefaultPageDialogOpen(false);
    setSelectedUser(null);

    // Show success message
    alert('Default page updated successfully!');

  } catch (error) {
    console.error('Error updating default page:', error);
    alert(error.message || 'Failed to update default page. Please try again.');
  } finally {
    setSavingDefaultPage(false);
  }
};

  const handleAnnouncementChange = (field, value) => {
    setAnnouncementForm(prev => ({
      ...prev,
      [field]: value
    }));
  };


  // Helper functions
  const getLicenseType = (user) => {
    // For now, all users have Free license
    return 'Free';
  };

  const getOrganizationInfo = (user) => {
    if (user.organizations && user.organizations.length > 0) {
      const org = user.organizations[0]; // Take first organization
      const totalMembers = org.teams.reduce((sum, team) => sum + team.team_members.length, 0);
      return {
        name: org.name,
        type: 'Owner',
        memberCount: totalMembers
      };
    }
    
    if (user.team_members && user.team_members.length > 0) {
      const membership = user.team_members[0]; // Take first membership
      return {
        name: membership.team.organization.name,
        type: 'Member',
        memberCount: null // We don't show member count for team members
      };
    }
    
    return {
      name: 'No Organization',
      type: 'Individual',
      memberCount: 0
    };
  };

const getUserInitials = (fullName) => {
  // Handle null, undefined, or empty string
  if (!fullName || typeof fullName !== 'string' || fullName.trim() === '') {
    return 'U';
  }
  
  // Clean and split the name, filter out empty strings
  const names = fullName.trim().split(' ').filter(name => name.length > 0);
  
  if (names.length >= 2) {
    // Get first char of first name and first char of last name
    return (names[0][0] + names[names.length - 1][0]).toUpperCase();
  }
  
  if (names.length === 1 && names[0].length > 0) {
    // For single name, return first two characters if available, otherwise first character
    return names[0].length >= 2 
      ? names[0].substring(0, 2).toUpperCase()
      : names[0][0].toUpperCase();
  }
  
  return 'U'; // Fallback for any edge cases
};

  const handleLogout = () => {
    localStorage.removeItem('superadmin_token');
    localStorage.removeItem('admin_user');
    navigate('/');
  };

const toggleUserStatus = async (userId, currentStatus) => {
  try {
    const token = localStorage.getItem('superadmin_token');
    if (!token) throw new Error('No authentication token found');

    const nextStatus = currentStatus === 'active' ? 'inactive' : 'active';

    const response = await fetch(
      `${BASE_URL}/user-analytics/user/${userId}/status`, // ya jo bhi final route ho
      {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: nextStatus }),
      }
    );

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.message || 'Failed to update user status');
    }

    // Local state update
    setDashboardData(prev => ({
      ...prev,
      users: prev.users.map(user =>
        user.id === userId
          ? { ...user, status: nextStatus }
          : user
      ),
    }));
  } catch (err) {
    console.error('Error updating user status:', err);
    alert(err.message || 'Failed to update user status');
  }
};


 const viewUserDashboard = (userId) => {
  // Navigate to user detail page with user ID
  navigate(`/user-detail/${userId}`);
};


// const manageUserLicense = (userId) => {
//   navigate(`/manage-license/${userId}`);
// };

  const filteredUsers = dashboardData.users.filter(user =>
    user.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get current data for active tab
  const getCurrentRevenueData = () => {
    switch(activeRevenueTab) {
      case 'mrr': return revenueData.mrr;
      case 'arr': return revenueData.arr;
      default: return revenueData.totalSales;
    }
  };

  // Format currency
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  // Custom tooltip for charts
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-medium">{`${label} ${revenueYear}`}</p>
          <p className="text-blue-600">
            {`${activeRevenueTab.toUpperCase()}: ${formatCurrency(payload[0].value)}`}
          </p>
        </div>
      );
    }
    return null;
  };

  // Profile dropdown component
  const ProfileDropdown = () => (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <UserCircle className="h-6 w-6" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium">{adminUser?.username || 'SuperAdmin'}</p>
            <p className="text-xs text-muted-foreground">{adminUser?.email || 'admin@revynox.com'}</p>
            <p className="text-xs text-muted-foreground">Role: {adminUser?.role || 'SuperAdmin'}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/profile')}>
  <User className="mr-2 h-4 w-4" />
  Profile Settings
</DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout} className="text-red-600">
          <LogOut className="mr-2 h-4 w-4" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  // Loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex items-center gap-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Loading super admin dashboard...</span>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-red-600 mb-4">
            <Shield className="h-12 w-12 mx-auto mb-2" />
            <h2 className="text-xl font-semibold">Error Loading Dashboard</h2>
          </div>
          <p className="text-gray-600 mb-4">{error}</p>
          <div className="space-x-2">
            <Button onClick={() => fetchSuperAdminData()}>
              <RefreshCw className="h-4 w-4 mr-2" />
              Try Again
            </Button>
            <Button variant="outline" onClick={() => navigate('/login')}>
              Go to Login
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <AppHeader title="Admin Dashboard">
        <div className="flex items-center gap-4">
           <Button
            variant="default"
            onClick={() => setAnnouncementDialogOpen(true)}
            className="bg-blue-600 hover:bg-blue-700"
          >
            <Megaphone className="h-4 w-4 mr-2" />
            Add Announcement
          </Button>

          <Button onClick={fetchSuperAdminData} variant="outline" size="sm" disabled={loading}>
            <RefreshCw className={`mr-2 h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
            Refresh
          </Button>

          <ProfileDropdown />
        </div>
      </AppHeader>
{/* Announcement Dialog */}
      <Dialog open={announcementDialogOpen} onOpenChange={setAnnouncementDialogOpen}>
        <DialogContent className="sm:max-w-[600px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Megaphone className="h-5 w-5" />
              Create New Announcement
            </DialogTitle>
            <DialogDescription>
              Create an announcement that will be displayed to users. Set activation status.
            </DialogDescription>
          </DialogHeader>
          
          <form onSubmit={handleAnnouncementSubmit}>
            <div className="grid gap-4 py-4">
              {/* Title */}
              <div className="grid gap-2">
                <Label htmlFor="title">Title (Optional)</Label>
                <Input
                  id="title"
                  placeholder="Enter announcement title"
                  value={announcementForm.title}
                  onChange={(e) => handleAnnouncementChange('title', e.target.value)}
                />
              </div>

              {/* Message */}
              <div className="grid gap-2">
                <Label htmlFor="message">Message *</Label>
                <Textarea
                  id="message"
                  placeholder="Enter announcement message"
                  value={announcementForm.message}
                  onChange={(e) => handleAnnouncementChange('message', e.target.value)}
                  required
                  rows={4}
                />
              </div>

              {/* Colors */}
              {/* <div className="grid grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="bg_color">Background Color</Label>
                  <div className="flex gap-2">
                    <Input
                      id="bg_color"
                      type="color"
                      value={announcementForm.bg_color}
                      onChange={(e) => handleAnnouncementChange('bg_color', e.target.value)}
                      className="w-16 h-10"
                    />
                    <Input
                      type="text"
                      value={announcementForm.bg_color}
                      onChange={(e) => handleAnnouncementChange('bg_color', e.target.value)}
                      placeholder="#16a34a"
                      className="flex-1"
                    />
                  </div>
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="text_color">Text Color</Label>
                  <div className="flex gap-2">
                    <Input
                      id="text_color"
                      type="color"
                      value={announcementForm.text_color}
                      onChange={(e) => handleAnnouncementChange('text_color', e.target.value)}
                      className="w-16 h-10"
                    />
                    <Input
                      type="text"
                      value={announcementForm.text_color}
                      onChange={(e) => handleAnnouncementChange('text_color', e.target.value)}
                      placeholder="#ffffff"
                      className="flex-1"
                    />
                  </div>
                </div>
              </div>

              <div className="grid gap-2">
                <Label>Preview</Label>
                <div 
                  className="p-4 rounded-lg text-center"
                  style={{
                    backgroundColor: announcementForm.bg_color,
                    color: announcementForm.text_color
                  }}
                >
                  {announcementForm.title && (
                    <div className="font-bold mb-1">{announcementForm.title}</div>
                  )}
                  <div>{announcementForm.message || 'Your announcement message will appear here...'}</div>
                </div>
              </div> */}

              {/* Dates */}
              {/* <div className="grid grid-cols-2 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="start_date">Start Date (Optional)</Label>
                  <Input
                    id="start_date"
                    type="datetime-local"
                    value={announcementForm.start_date}
                    onChange={(e) => handleAnnouncementChange('start_date', e.target.value)}
                  />
                </div>

                <div className="grid gap-2">
                  <Label htmlFor="end_date">End Date (Optional)</Label>
                  <Input
                    id="end_date"
                    type="datetime-local"
                    value={announcementForm.end_date}
                    onChange={(e) => handleAnnouncementChange('end_date', e.target.value)}
                  />
                </div>
              </div> */}

              {/* Active Status */}
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="is_active"
                  checked={announcementForm.is_active}
                  onChange={(e) => handleAnnouncementChange('is_active', e.target.checked)}
                  className="h-4 w-4 rounded border-gray-300"
                />
                <Label htmlFor="is_active" className="cursor-pointer">
                  Mark as Active (Display immediately)
                </Label>
              </div>
            </div>

            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => setAnnouncementDialogOpen(false)}
                disabled={savingAnnouncement}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={savingAnnouncement || !announcementForm.message}>
                {savingAnnouncement ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <PlusCircle className="h-4 w-4 mr-2" />
                    Create Announcement
                  </>
                )}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>

{/* Set Default Page Dialog */}
<Dialog open={defaultPageDialogOpen} onOpenChange={setDefaultPageDialogOpen}>
  <DialogContent className="sm:max-w-[425px]">
    <DialogHeader>
      <DialogTitle className="flex items-center gap-2">
        <LayoutDashboard className="h-5 w-5" />
        Set Default Page
      </DialogTitle>
      <DialogDescription>
        Choose the default landing page for {selectedUser?.fullName || 'this user'}. 
        This page will open automatically when they login.
      </DialogDescription>
    </DialogHeader>

    <div className="py-4">
      {loadingDefaultPage ? (
        // Loading State - Shows spinner
        <div className="flex flex-col items-center justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600 mb-3" />
          <span className="text-sm text-gray-600">Loading current settings...</span>
        </div>
      ) : (
        // Content State - Shows radio buttons
        <div className="space-y-4">
          {/* Radio Button Options */}
          <div className="space-y-3">
            <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
              <input
                type="radio"
                name="defaultPage"
                value="maindashboard"
                checked={selectedDefaultPage === 'maindashboard'}
                onChange={(e) => setSelectedDefaultPage(e.target.value)}
                className="w-4 h-4 text-blue-600"
              />
              <div className="flex items-center gap-2 flex-1">
                <LayoutDashboard className="h-4 w-4 text-gray-600" />
                <div>
                  <div className="font-medium">Main Dashboard</div>
                  <div className="text-sm text-gray-500">Default landing page</div>
                </div>
              </div>
            </label>

            <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
              <input
                type="radio"
                name="defaultPage"
                value="esignature"
                checked={selectedDefaultPage === 'esignature'}
                onChange={(e) => setSelectedDefaultPage(e.target.value)}
                className="w-4 h-4 text-blue-600"
              />
              <div className="flex items-center gap-2 flex-1">
                <ClipboardCheck className="h-4 w-4 text-gray-600" />
                <div>
                  <div className="font-medium">E-Signature</div>
                  <div className="text-sm text-gray-500">Digital signature management</div>
                </div>
              </div>
            </label>

            <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
              <input
                type="radio"
                name="defaultPage"
                value="invoicing"
                checked={selectedDefaultPage === 'invoicing'}
                onChange={(e) => setSelectedDefaultPage(e.target.value)}
                className="w-4 h-4 text-blue-600"
              />
              <div className="flex items-center gap-2 flex-1">
                <DollarSign className="h-4 w-4 text-gray-600" />
                <div>
                  <div className="font-medium">Invoicing</div>
                  <div className="text-sm text-gray-500">Invoice creation and management</div>
                </div>
              </div>
            </label>
          </div>

          {/* Current Status */}
          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="text-sm text-blue-800">
              <strong>Current Default:</strong> {selectedUser?.defaultpage || 'maindashboard'}
            </div>
          </div>
        </div>
      )}
    </div>

    <DialogFooter>
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          setDefaultPageDialogOpen(false);
          setSelectedUser(null);
        }}
        disabled={savingDefaultPage || loadingDefaultPage}
      >
        Cancel
      </Button>
      <Button 
        onClick={handleDefaultPageSubmit} 
        disabled={savingDefaultPage || loadingDefaultPage}
      >
        {savingDefaultPage ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Settings className="h-4 w-4 mr-2" />
            Save Default Page
          </>
        )}
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>
      <main className="flex-1 p-4 md:p-6 space-y-6">
        {/* Period Selector */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-semibold">User Statistics</h2>
          <Select value={selectedPeriod} onValueChange={setSelectedPeriod}>
            <SelectTrigger className="w-48">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="current-month">Current Month</SelectItem>
              <SelectItem value="last-month">Last Month</SelectItem>
              <SelectItem value="last-3-months">Last 3 Months</SelectItem>
              <SelectItem value="last-year">Last Year</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Real Stats Cards */}
        <div className="grid gap-6 md:grid-cols-5">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardDescription>Total Users</CardDescription>
              <Users className="h-4 w-4 text-blue-600" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{dashboardData.statistics.totalUsers}</div>
              <p className="text-xs text-muted-foreground">
                {dashboardData.statistics.confirmedUsers} confirmed
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardDescription>Organization Owners</CardDescription>
              <Building className="h-4 w-4 text-purple-600" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{dashboardData.statistics.ownersCount}</div>
              <p className="text-xs text-muted-foreground">
                {dashboardData.statistics.totalOrganizations} organizations
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardDescription>Team Members</CardDescription>
              <UserCheck className="h-4 w-4 text-blue-600" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{dashboardData.statistics.teamMembersCount}</div>
              <p className="text-xs text-muted-foreground">
                Active team members
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardDescription>Confirmed Users</CardDescription>
              <Users className="h-4 w-4 text-green-600" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold text-green-600">{dashboardData.statistics.confirmedUsers}</div>
              <p className="text-xs text-muted-foreground">Email verified</p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardDescription>Unconfirmed Users</CardDescription>
              <Users className="h-4 w-4 text-orange-600" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold text-orange-600">{dashboardData.statistics.unconfirmedUsers}</div>
              <p className="text-xs text-muted-foreground">Need verification</p>
            </CardContent>
          </Card>
        </div>

        {/* Real User Management Section */}
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <CardTitle className="flex items-center gap-2">
                  <Users className="h-5 w-5" />
                  User Management
                </CardTitle>
                <CardDescription>
                  View user accounts, organizations, and team structures. Total: {dashboardData.statistics.totalUsers} users
                </CardDescription>
              </div>
              <div className="flex items-center gap-2">
                <div className="relative">
                  <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                  <input
                    placeholder="Search users..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-8 pr-4 py-2 border rounded-md text-sm w-64"
                  />
                </div>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {/* Table Header */}
              <div className="grid grid-cols-12 gap-4 text-sm font-medium text-muted-foreground border-b pb-2">
                <div className="col-span-1">Avatar</div>
                <div className="col-span-3">Name / Organization</div>
                <div className="col-span-3">Email / Team Info</div>
                <div className="col-span-2">License Type</div>
                <div className="col-span-1">Status</div>
                <div className="col-span-2">Actions</div>
              </div>

              {/* Real User Rows */}
              {filteredUsers.map((user) => {
                const licenseType = getLicenseType(user);
                const orgInfo = getOrganizationInfo(user);
                
                return (
                  <div key={user.id} className="grid grid-cols-12 gap-4 items-center py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors">
                    {/* Avatar */}
                    <div className="col-span-1">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-sm font-medium text-white">
                        {getUserInitials(user.fullName)}
                      </div>
                    </div>

                    {/* Name / Organization */}
                    <div className="col-span-3">
                      <div className="font-medium">{user.fullName || 'No Name'}</div>
                      <div className="text-sm text-muted-foreground flex items-center gap-2">
                        <Building className="h-3 w-3" />
                        <span>{orgInfo.name}</span>
                        {orgInfo.memberCount !== null && (
                          <span className="flex items-center gap-1">
                            <Users className="h-3 w-3" />
                            {orgInfo.memberCount} members
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Email / Team Info */}
                    <div className="col-span-3">
                      <div className="font-medium text-sm">{user.email}</div>
                      <div className="text-sm text-muted-foreground">
                        <span className="capitalize">{orgInfo.type}</span>
                        {user.userType && (
                          <span className="ml-2 text-blue-600">• {user.userType.replace('_', ' ')}</span>
                        )}
                      </div>
                    </div>

                    {/* License Type */}
                    <div className="col-span-2">
                      <Badge variant={
                        licenseType === 'Enterprise' ? 'default' : 
                        licenseType === 'Premium' ? 'secondary' : 
                        licenseType === 'Team Member' ? 'outline' :
                        'destructive'
                      }>
                        {licenseType}
                      </Badge>
                    </div>

                    {/* Status */}
                    <div className="col-span-1">
                     <Badge variant={user.status === 'active' ? 'default' : 'destructive'}>
  {user.status === 'active' ? 'Active' : 'Inactive'}
</Badge>

                    </div>

                    {/* Actions */}
                    <div className="col-span-2 flex items-center gap-2">
                  <Button
  variant="ghost"
  size="sm"
  onClick={() => toggleUserStatus(user.id, user.status)}
  className="p-1"
  title={user.status === 'active' ? 'Deactivate User' : 'Activate User'}
>
  {user.status === 'active' ? (
    <ToggleRight className="h-5 w-5 text-green-600" />
  ) : (
    <ToggleLeft className="h-5 w-5 text-gray-400" />
  )}
</Button>
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <Button variant="ghost" size="sm">
                            <MoreHorizontal className="h-4 w-4" />
                          </Button>
                        </DropdownMenuTrigger>
                     <DropdownMenuContent align="end">
                          <DropdownMenuItem onClick={() => viewUserDashboard(user.id)}>
                            <Eye className="mr-2 h-4 w-4" />
                            View Details
                          </DropdownMenuItem>
                          <DropdownMenuItem onClick={() => navigate(`/manage-license/${user.id}`)}> {/* 👈 Yahan user.id aayega */}
                            <Settings className="mr-2 h-4 w-4" />
                            Manage License
                          </DropdownMenuItem>
                          <DropdownMenuSeparator />
                          <DropdownMenuItem onClick={() => openDefaultPageDialog(user)}>
                            <LayoutDashboard className="mr-2 h-4 w-4" />
                            Set Default Page
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                  </div>
                );
              })}

              {filteredUsers.length === 0 && (
                <div className="text-center py-8 text-muted-foreground">
                  {searchTerm ? 'No users found matching your search.' : 'No users found.'}
                </div>
              )}
            </div>
          </CardContent>
        </Card>

        {/* Revenue Metrics Section (Mock Data) */}
        <Card className="mt-8">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <CardTitle className="flex items-center gap-2">
                  <BarChart3 className="h-5 w-5" />
                  Revenue Metrics
                </CardTitle>
                <CardDescription>
                  Visualize sales, MRR, and ARR trends (Demo Data).
                </CardDescription>
              </div>
              <Select value={revenueYear} onValueChange={setRevenueYear}>
                <SelectTrigger className="w-32">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="2024">2024</SelectItem>
                  <SelectItem value="2023">2023</SelectItem>
                  <SelectItem value="2022">2022</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </CardHeader>
          <CardContent>
            {/* Revenue Tab Navigation */}
            <div className="flex border-b border-gray-200 mb-6">
              <button
                onClick={() => setActiveRevenueTab('sales')}
                className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeRevenueTab === 'sales' 
                    ? 'border-blue-500 text-blue-600' 
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                <DollarSign className="inline h-4 w-4 mr-2" />
                Total Sales
              </button>
              <button
                onClick={() => setActiveRevenueTab('mrr')}
                className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeRevenueTab === 'mrr' 
                    ? 'border-blue-500 text-blue-600' 
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                <TrendingUp className="inline h-4 w-4 mr-2" />
                MRR
              </button>
              <button
                onClick={() => setActiveRevenueTab('arr')}
                className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeRevenueTab === 'arr' 
                    ? 'border-blue-500 text-blue-600' 
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                <TrendingUp className="inline h-4 w-4 mr-2" />
                ARR
              </button>
            </div>

            {/* Chart */}
            <div className="h-96">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={getCurrentRevenueData()}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 40,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                  <XAxis 
                    dataKey="month" 
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: '#666' }}
                  />
                  <YAxis 
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 12, fill: '#666' }}
                    tickFormatter={formatCurrency}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Bar 
                    dataKey="value" 
                    fill="#6366f1"
                    radius={[4, 4, 0, 0]}
                    name={`${activeRevenueTab.toUpperCase()} - ${revenueYear}`}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>

            {/* Revenue Summary */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 pt-6 border-t">
              <div className="text-center">
                <p className="text-sm text-gray-500">Current Month</p>
                <p className="text-2xl font-bold text-gray-900">
                  {formatCurrency(getCurrentRevenueData()[getCurrentRevenueData().length - 1]?.value || 0)}
                </p>
              </div>
              <div className="text-center">
                <p className="text-sm text-gray-500">Average Monthly</p>
                <p className="text-2xl font-bold text-gray-900">
                  {formatCurrency(
                    getCurrentRevenueData().reduce((sum, item) => sum + item.value, 0) / 
                    getCurrentRevenueData().length
                  )}
                </p>
              </div>
              <div className="text-center">
                <p className="text-sm text-gray-500">Total YTD</p>
                <p className="text-2xl font-bold text-gray-900">
                  {formatCurrency(getCurrentRevenueData().reduce((sum, item) => sum + item.value, 0))}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>
    </>
  );
}